import React from 'react'
import orderInfomation from 'config/orderInformation.json';
import { pickupsDeliveryIds, pickupsBlocklistIds } from 'config/orderDelivery.json';
import { SimpleDetails, GroupedDetails, PickupPointDetails, InvoiceDetails } from './Details';

const OrderInformation = ({ props }) => {

    return (
        <ul className="order__list">
            {orderInfomation.map((item, key) => {
                return item.data.length
                    ? (
                        props.delivery && !pickupsBlocklistIds.includes(Number(props.delivery.id)) && pickupsDeliveryIds.includes(Number(props.delivery.id))
                            ? (<PickupPointDetails key={key} {...item} props={props} keys={item.data} />)
                            : (<React.Fragment key={key}>
                                <GroupedDetails {...item} props={props} keys={item.data} />
                                {props.shipping['invoiceData'] && <InvoiceDetails {...item} props={props} keys={item.data} />}
                            </React.Fragment>)
                    )
                    : (
                        <SimpleDetails key={key} {...item} props={props} />
                    );
            })}
        </ul>
    )
}

export default OrderInformation;
